import Pikaday from 'pikaday';

import moment from 'moment';
import 'moment/locale/fr';

moment.locale('fr');

export default class Calendar {

    constructor($view) {
        this.$view = $view;
        this.bind();
    }

    bind() {

        let picker = new Pikaday({
            field: this.$view[0],
            bound: false,
            container: this.$view[0],
            defaultDate: moment().format("DD MM YYYY"),
            showDaysInNextAndPreviousMonths: true,
            events: this.getEvenementsDate(),
            onSelect: function() {
                $.ajax({
                    url: $('.event-blocks').data('url_update'),
                    method: 'GET',
                    data: {'selected_date' : this.getMoment().format('DD/MM/YYYY')},
                    success : function (data) {
                        $.each(data.templates, (templateName, templateHtml) => {
                            let $element = $('.event-blocks', 'body');
                            if ($element.length) {
                                $element.children().remove();
                                $element.append(templateHtml);
                            }
                        });
                        window.Kernel.mountComponents($('html'));
                    },
                });
            },
            i18n: {
                previousMonth: 'Mois précédent',
                nextMonth: 'Mois suivant',
                months: moment.localeData()._months,
                weekdays: moment.localeData()._weekdays,
                weekdaysShort:  moment.localeData()._weekdaysShort
            }
        });

    }

    getEvenementsDate(){
        var dates = '';
         $.ajax({
            url:"/evenements/date",
            async: false,
            success:function(data) {
                dates = data;
            }
        });

        return dates;
    }
}